<template>
  <article class="flex flex-col">
    <div class="mb-[120px] flex gap-[20px]">
      <div class="flex flex-col xl:w-3/4 2xl:w-4/5">
        <h1
          class="mb-[28px] text-[32px] font-medium leading-[38px]"
          v-text="courseInfo?.title"
        />
        <CommonBlocksImageArticleBlock
          v-if="courseInfo?.image"
          class="mb-[32px]"
          :published-at="courseInfo?.published_at"
          :src="courseInfo?.image.src"
        />
        <div v-if="data?.length" class="page-body no-dynamic-format mb-[65px]">
          <CardsCourseContentCard
            v-for="(course, index) in data"
            :key="course.id"
            class="mb-[48px] last:mb-0"
            state="video"
            :data="course"
            :index="index"
          />
        </div>
      </div>
      <CommonBlocksRightArticleBlock class="xl:w-1/4 2xl:w-1/5" />
    </div>
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
definePageMeta({
  layout: 'marginless',
});

const route = useRoute();
const slug = route?.params?.slug;

const { courseSlug } = useCourseSlug(slug);
const courseInfo = computed(() => courseSlug?.data?.value?.course);
const title = computed(() => courseInfo?.value?.title);
const data = computed(() => courseSlug?.data?.value?.data);

// const seo = computed(() => courseInfo?.value?.seo); // seo в курсе отсутствует

useHead(
  computed(() => ({
    title: `${
      title.value ? `${title.value} |` : ''
    } Смотреть видеокурсы по истории РФ для школьников и студентов`,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: `${
          title.value ? title.value : ''
        }. Смотреть видеокурсы по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `${title.value}`,
      },
      {
        hid: 'robots',
        name: 'robots',
      },
    ],
  })),
);

// import CourseContentCard from '@/components/Cards/CourseContentCard';
// import authorInfo from '@/components/Common/AuthorInfo';
// import imageArticleBlock from '@/components/Common/Blocks/ImageArticleBlock';
// import pageFooterBlocks from '@/components/Common/Blocks/PageFooterBlocks';
// import RightArticleBlock from '@/components/Common/Blocks/RightArticleBlock';
// import api from '@/services/api/api';

// export default {
//   components: {
//     imageArticleBlock,
//     pageFooterBlocks,
//     RightArticleBlock,
//     authorInfo,
//     CourseContentCard,
//   },

//   layout: 'marginless',

//   async asyncData({ route, error }) {
//     try {
//       const slug = route.params.slug;
//       const { data } = await api.courses.getCourseBySlug(slug);

//       let robots;
//       if (data.course.seo) {
//         const arr = [];
//         if (data.course.seo.index === false) arr.push('noindex');
//         if (data.course.seo.follow === false) arr.push('nofollow');
//         if (data.course.seo.archive === false) arr.push('noarchive');
//         if (arr.length > 0) {
//           robots = arr.reduce((previousValue, currentValue) => {
//             return `${previousValue}, ${currentValue}`;
//           });
//         }
//       }

//       return {
//         data: data?.data,
//         courseInfo: data?.course,
//         image: data?.image,
//         seo: data?.course?.seo ?? {},
//         robots: robots ?? 'all',
//       };
//     } catch (e) {
//       console.log(e);
//       error({ statusCode: e.response?.status ?? 503 });
//     }
//   },

//   data() {
//     return {
//       data: [],
//       courseInfo: {},
//       seo: {},
//       image: {},
//       robots: 'all',
//     };
//   },

//   head() {
//     return {
//       title: `${this.data?.title} | Смотреть видеокурсы по истории РФ для школьников и студентов`,
//       meta: [
//         {
//           hid: 'description',
//           name: 'description',
//           content: `${
//             this.seo.metadescription ||
//             this.seo.metatitle ||
//             this.courseInfo.title
//           }. Смотреть видеокурсы по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
//         },
//         {
//           hid: 'keywords',
//           name: 'keywords',
//           content: `${this.data?.title}`,
//         },
//         {
//           hid: 'robots',
//           name: 'robots',
//           content: this.robots,
//         },
//       ],
//     };
//   },
// };
</script>
